import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Search, ChevronDown, Calculator, GraduationCap, BookOpen, Gift, Dices, Trophy } from "lucide-react";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";

const MENU = [
  {
    label: "Játékok",
    icon: Dices,
    items: [
      { label: "Összes játék", to: "/jatekok" },
      { label: "Nyerőgépek", to: "/jatekok/nyerogepek" },
      { label: "Élő kaszinó játékok", to: "/jatekok/elo-kaszino" },
      { label: "Rulett", to: "/jatekok/rulett" },
      { label: "Blackjack", to: "/jatekok/blackjack" },
      { label: "Aviator (crash játék)", to: "/aviator" },
      { label: "Sweet Bonanza", to: "/sweet-bonanza" },
      { label: "Gates of Olympus", to: "/gates-of-olympus" },
      { label: "JetX", to: "/jetx" },
      { label: "Book of Ra", to: "/book-of-ra" },
      { label: "Sizzling Hot", to: "/sizzling-hot" },
      { label: "Játékszolgáltatók", to: "/jatek-szolgaltatok" },
    ],
  },
  {
    label: "Kaszinók",
    icon: Dices,
    items: [
      { label: "Top kaszinók", to: "/kaszinok" },
      { label: "Új kaszinók", to: "/uj-kaszinok" },
      { label: "Élő kaszinó", to: "/elo-kaszino" },
      { label: "Crypto kaszinók", to: "/crypto-kaszino" },
      { label: "HUF kaszinók", to: "/huf-kaszinok" },
      { label: "Befizetés nélküli bónusz", to: "/befizetes-nelkuli-bonusz" },
      { label: "Ingyenes pörgetések", to: "/ingyenes-porgetesek" },
      { label: "Mobil kaszinó", to: "/mobil-kaszino" },
    ],
  },
  {
    label: "Sportfogadás",
    icon: Trophy,
    items: [
      { label: "Top bukmékerek", to: "/sportfogadas" },
      { label: "Új bukmékerek", to: "/uj-bukmekerek" },
      { label: "Gyors kifizetés", to: "/gyors-kifizetes-bukmekerek" },
      { label: "Live fogadás", to: "/live-fogadas" },
      { label: "Crypto bukmékerek", to: "/crypto-bukmekerek" },
      { label: "Bajnokok Ligája", to: "/bajnokok-ligaja" },
      { label: "Sportok", to: "/sportok" },
      { label: "Heinz fogadás", to: "/fogadas-tipusok/heinz" },
      { label: "Yankee fogadás", to: "/fogadas-tipusok/yankee" },
      { label: "Canadian fogadás", to: "/fogadas-tipusok/canadian" },
      { label: "Banker fogadás", to: "/fogadas-tipusok/banker" },
      { label: "Lucky 15 fogadás", to: "/fogadas-tipusok/lucky15" },
      { label: "Bankroll management", to: "/bankroll-management" },
      { label: "Tippmix alternatíva", to: "/tippmix-helyett" },
      { label: "TippmixPro alternatíva", to: "/tippmixpro-helyett" },
      { label: "Vegas.hu alternatíva", to: "/vegas-hu-helyett" },
      { label: "Unibet alternatíva", to: "/unibet-helyett" },
      { label: "Bet365 alternatíva", to: "/bet365-helyett" },
    ],
  },
  {
    label: "Bónuszok",
    icon: Gift,
    items: [
      { label: "Összes bónusz", to: "/bonuszok" },
      { label: "Üdvözlő bónusz", to: "/bonuszok/udvozlo" },
      { label: "Befizetés nélküli", to: "/bonuszok/befizetes-nelkuli" },
      { label: "Free spins", to: "/bonuszok/free-spins" },
      { label: "Cashback", to: "/bonuszok/cashback" },
      { label: "Reload bónusz", to: "/bonuszok/reload" },
      { label: "VIP / Hűségprogram", to: "/bonuszok/vip" },
      { label: "Összes promóciós kód", to: "/promocios-kodok" },
      { label: "SpinBetter promó kód", to: "/promocios-kodok/spinbetter" },
      { label: "22Casino promó kód", to: "/promocios-kodok/22casino" },
      { label: "Megapari promó kód", to: "/promocios-kodok/megapari" },
      { label: "PariPesa promó kód", to: "/promocios-kodok/paripesa" },
      { label: "HellSpin promó kód", to: "/promocios-kodok/hellspin" },
    ],
  },
  {
    label: "Kalkulátorok",
    icon: Calculator,
    items: [
      { label: "Összes kalkulátor (20+)", to: "/kalkulatorok" },
      { label: "Arbitrázs", to: "/kalkulatorok/arbitrazs" },
      { label: "Wagering (forgatási)", to: "/kalkulatorok/wagering" },
      { label: "Kelly Criterion", to: "/kalkulatorok/kelly" },
      { label: "Parlay (kombi)", to: "/kalkulatorok/parlay" },
      { label: "Odds konverter", to: "/kalkulatorok/odds-konverter" },
      { label: "Hedge", to: "/kalkulatorok/hedge" },
      { label: "Dutching", to: "/kalkulatorok/dutching" },
      { label: "Martingale szimulátor", to: "/kalkulatorok/martingale" },
      { label: "Rendszerszelvény", to: "/kalkulatorok/rendszerszelveny" },
    ],
  },
  {
    label: "Tudás",
    icon: GraduationCap,
    items: [
      { label: "Stratégiák", to: "/strategiak" },
      { label: "Sportfogadás akadémia", to: "/akademia/sportfogadas" },
      { label: "Kaszinó akadémia", to: "/akademia/kaszino" },
      { label: "Szakszótár (sport)", to: "/szakszotar/sport" },
      { label: "Szakszótár (kaszinó)", to: "/szakszotar/kaszino" },
      { label: "Fizetési módok (összes)", to: "/fizetesi-modok" },
      { label: "Skrill kaszinó", to: "/fizetesi-modok/skrill" },
      { label: "Revolut kaszinó", to: "/fizetesi-modok/revolut" },
      { label: "PaySafeCard kaszinó", to: "/fizetesi-modok/paysafecard" },
      { label: "Neteller kaszinó", to: "/fizetesi-modok/neteller" },
      { label: "OTP Bank kaszinó", to: "/fizetesi-modok/otp-bank" },
      { label: "Játékszolgáltatók", to: "/jatek-szolgaltatok" },
      { label: "Biztonság & Licencek", to: "/biztonsag-licencek" },
    ],
  },
  {
    label: "Blog",
    icon: BookOpen,
    items: [
      { label: "Összes cikk", to: "/blog" },
      { label: "Sport hírek", to: "/blog?category=hirek" },
      { label: "Stratégia", to: "/blog?category=strategia" },
      { label: "Kvíz: Melyik kaszinó nekem?", to: "/melyik-a-tokeletes-kaszino" },
      { label: "Felelős játék", to: "/felelos-jatek" },
    ],
  },
];

export default function Header() {
  const [openMobile, setOpenMobile] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQ, setSearchQ] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setOpenMobile(false);
    setOpenMenu(null);
  }, [location.pathname]);

  useEffect(() => {
    if (!searchQ || searchQ.length < 2) {
      setSearchResults(null);
      return;
    }
    const t = setTimeout(async () => {
      try {
        const r = await api.get("/search", { params: { q: searchQ } });
        setSearchResults(r.data);
      } catch {
        setSearchResults(null);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [searchQ]);

  return (
    <header className="sticky top-0 z-50 glass-strong border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl 2xl:max-w-[1536px] mx-auto px-4 lg:px-6">
        <div className="flex items-center justify-between h-16 lg:h-20 gap-2 sm:gap-4">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 group min-w-0" data-testid="logo-link">
            <Logo
              size={48}
              className="shrink-0 w-9 h-9 sm:w-12 sm:h-12 drop-shadow-[0_4px_12px_rgba(212,175,55,0.35)] group-hover:drop-shadow-[0_4px_18px_rgba(212,175,55,0.6)] transition-all duration-300"
            />
            <div className="block min-w-0">
              <div className="font-display font-black text-lg sm:text-xl md:text-2xl leading-none text-white tracking-tight whitespace-nowrap">
                Bonusz<span className="text-gold">vadász</span>
              </div>
              <div className="hidden md:block text-[10px] uppercase tracking-[0.18em] text-white/45 mt-1 font-semibold">
                Független szakértői portál
              </div>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden xl:flex items-center gap-1 flex-1 justify-center" data-testid="desktop-nav">
            {MENU.map((m) => (
              <div
                key={m.label}
                className="relative"
                onMouseEnter={() => setOpenMenu(m.label)}
                onMouseLeave={() => setOpenMenu(null)}
              >
                <button
                  className="px-2 xl:px-3 py-2 text-sm font-medium text-white/80 hover:text-gold transition-colors flex items-center gap-1 rounded-md whitespace-nowrap"
                  data-testid={`nav-${m.label}`}
                >
                  {m.label}
                  <ChevronDown size={14} className="opacity-60" />
                </button>
                {openMenu === m.label && (
                  <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 w-64">
                    <div className="glass-strong rounded-xl py-2 border border-white/10 shadow-2xl animate-fade-up">
                      {m.items.map((it) => (
                        <NavLink
                          key={it.to}
                          to={it.to}
                          className={({ isActive }) =>
                            `block px-4 py-2 text-sm transition-colors ${isActive ? "text-gold bg-white/5" : "text-white/80 hover:text-gold hover:bg-white/5"}`
                          }
                        >
                          {it.label}
                        </NavLink>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </nav>

          <div className="flex items-center gap-1 sm:gap-2 shrink-0">
            <LanguageSwitcher />
            <button
              onClick={() => setSearchOpen((v) => !v)}
              className="p-2 rounded-lg hover:bg-white/5 text-white/70 hover:text-gold transition-colors"
              data-testid="search-toggle"
              aria-label="Keresés"
            >
              <Search size={18} />
            </button>
            <Link
              to="/melyik-a-tokeletes-kaszino"
              className="hidden md:inline-flex xl:hidden 2xl:inline-flex items-center gap-1.5 gold-btn px-4 py-2 rounded-lg text-sm whitespace-nowrap"
              data-testid="quiz-cta"
            >
              <Trophy size={14} />
              Kvíz: Melyik kaszinó nekem?
            </Link>
            <button
              className="xl:hidden p-2 rounded-lg hover:bg-white/5 text-white"
              onClick={() => setOpenMobile((v) => !v)}
              data-testid="mobile-menu-toggle"
              aria-label="Menü"
            >
              {openMobile ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="pb-4 animate-fade-up">
            <input
              autoFocus
              value={searchQ}
              onChange={(e) => setSearchQ(e.target.value)}
              placeholder="Keress kaszinók, bukmékerek, cikkek között..."
              className="w-full glass rounded-lg px-4 py-3 text-white outline-none focus:ring-2 focus:ring-gold/50"
              data-testid="search-input"
            />
            {searchResults && (
              <div className="glass-strong rounded-lg mt-2 max-h-80 overflow-auto p-2" data-testid="search-results">
                {[
                  ["Kaszinók", searchResults.casinos, "/kaszinok"],
                  ["Bukmékerek", searchResults.bookmakers, "/sportfogadas"],
                  ["Blog", searchResults.blog, "/blog"],
                ].map(([label, items, basepath]) =>
                  items && items.length ? (
                    <div key={label} className="mb-2">
                      <div className="text-xs uppercase tracking-wider text-white/40 px-2 py-1">{label}</div>
                      {items.map((it) => (
                        <Link
                          key={it.slug}
                          to={`${basepath}/${it.slug}`}
                          className="block px-3 py-2 rounded hover:bg-white/5 text-white/90 text-sm"
                          onClick={() => setSearchOpen(false)}
                        >
                          {it.name || it.title}
                        </Link>
                      ))}
                    </div>
                  ) : null
                )}
                {!searchResults.casinos.length && !searchResults.bookmakers.length && !searchResults.blog.length && (
                  <div className="p-4 text-white/50 text-sm">Nincs találat erre: <strong>{searchQ}</strong></div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Mobile menu */}
      {openMobile && (
        <div className="xl:hidden border-t border-white/10 bg-background/95 backdrop-blur-xl max-h-[80vh] overflow-y-auto" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-1">
            {MENU.map((m) => (
              <details key={m.label} className="group">
                <summary className="flex items-center justify-between cursor-pointer py-3 px-3 rounded-lg hover:bg-white/5 text-white font-medium">
                  <span className="flex items-center gap-2"><m.icon size={16} className="text-gold" />{m.label}</span>
                  <ChevronDown size={16} className="group-open:rotate-180 transition-transform" />
                </summary>
                <div className="pl-9 py-1 space-y-1">
                  {m.items.map((it) => (
                    <NavLink
                      key={it.to}
                      to={it.to}
                      className={({ isActive }) =>
                        `block py-2 text-sm ${isActive ? "text-gold" : "text-white/70 hover:text-gold"}`
                      }
                    >
                      {it.label}
                    </NavLink>
                  ))}
                </div>
              </details>
            ))}
            <Link
              to="/melyik-a-tokeletes-kaszino"
              className="block gold-btn rounded-lg px-4 py-3 text-center mt-4"
            >
              🎯 Kvíz: Melyik kaszinó nekem?
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
